import { Outlet } from 'react-router-dom'
import Secondgrade_k2_subjects from './secondgrade_k2_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Secondgrade_k2 = ( ) => {
 
  return (
    <>
   
   
   <TopNavbar />
  <Secondgrade_k2_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Secondgrade_k2;